import * as types from './types';
import initialState from './initial-state';

export default function contentStudioReducer(state = initialState, action) {
  switch (action.type) {
    case types.SET_KIE_CONFIGURED:
      return {
        ...state,
        isKieConfigured: action.payload,
      };

    case types.GENERATE_START:
      return {
        ...state,
        generating: true,
        taskId: null,
        generationId: null,
        progress: 0,
        status: 'submitting',
        output: null,
        error: null,
      };

    case types.TASK_CREATED:
      return {
        ...state,
        taskId: action.payload.taskId,
        generationId: action.payload.generationId,
        status: 'processing',
      };

    case types.PROGRESS:
      return {
        ...state,
        progress: action.payload.progress,
        status: action.payload.status,
      };

    case types.COMPLETED:
      return {
        ...state,
        generating: false,
        progress: 100,
        status: 'completed',
        output: action.payload,
      };

    case types.FAILED:
      return {
        ...state,
        generating: false,
        status: 'failed',
        error: action.payload,
      };

    case types.CANCEL:
      return {
        ...state,
        generating: false,
        taskId: null,
        generationId: null,
        progress: 0,
        status: null,
        output: null,
        error: null,
      };

    case types.SET_CREDITS:
      return {
        ...state,
        credits: action.payload,
      };

    default:
      return state;
  }
}
